<template>
	<div class="test-buy-page">
    <div class="page-header">
      <h2>{{ $t('testbuy.test_purchase_management') }}</h2>
    </div>

    <div class="kpis-complain-overview">
      <el-row :gutter="20">
        <el-col :xs="8" :sm="8">
          <div class="kpis-complain-overview-item">
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="kpis-complain-overview-item-row colorred">
                  <h2>
                    {{ $t('testbuy.total_test_purchase') }}
                  </h2>
                  <h3>{{ dashboarddata.totaltestbuy }}</h3>
                  <h4>&nbsp;</h4>
                </div>
                <div class="kpis-complain-overview-item-row mt20 colorgreen" style="margin-top: 30px;">
                  <h2>
                    {{ $t('testbuy.test_purchase_completed') }}
                  </h2>
                  <h3>{{ dashboarddata.successtestbuy }}</h3>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="progresscircle">
                  <el-progress
                    type="circle" 
                    :percentage="dashboarddata.completepercent" 
                    :format="formatprogress"
                    :stroke-width="10"
                    color="#1CAF9A"
                  >
                  </el-progress>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :xs="8" :sm="8">
          <div class="kpis-complain-overview-item">
            <h2>
              {{ $t('testbuy.test_purchase_duration') }}
              <span style="font-size:12px; margin-left:15px;">{{ $t('kpi.s20') }}</span>
            </h2>
            <MiniBarChart :chartdata="testbuytimeavg" minibarid="minibarid"/>
          </div>
        </el-col>
        <el-col :xs="8" :sm="8">
          <div class="kpis-complain-overview-item">
            <h2>{{ $t('testbuy.account_balance') }}</h2>
            <span style="color: #DD4141;"></span><el-button type="balance-detail" @click="gotoBalance()">{{ $t('testbuy.details') }}</el-button>
            <div class="testbuy-balance-amount">
              <el-statistic group-separator="," :title="$t('testbuy.available_balance')">
                <template slot="formatter">
                  <span :class="amount.total * 1 >= 0 ? 'report-numcarts-color-green' : 'report-numcarts-color-red'">
                    {{ millonFormat((amount.total *1), true) }}
                  </span>
                </template>
              </el-statistic>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>


    <div class="c-testbuy-dashboard-overview">
      <div class="test-buy-dashboard">
        <el-row :gutter="20">
          <el-col :span="71" v-for="item in statuscount" :key="item.status">
            <div class="topsummary-item">
              <el-button type="topsummary" @click="activeTestbuyList(item.status==11 ? '7,10,11' : item.status)">
                <h2>{{ item.count }}</h2>
                <h3>{{ item.name }}</h3>
              </el-button>
            </div>
          </el-col>
        </el-row>
      </div>    
    </div>
    
    <div class="test-buy-dashboards">
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="dashboard-container">
            <div class="dashboard-item">
              <h2>{{ $t('testbuy.test_purchase_type_distribution') }}</h2>
              <div class="dashboard-chart-bar-container">
                <div class="dashboard-chart-bar-component" id="barchartid3"></div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="dashboard-container">
            <div class="dashboard-item">
              <h2>{{ $t('Seller.t4') }}</h2>
              <div class="dashboard-chart-bar-container">
                <div class="dashboard-chart-bar-component" id="barchartid4"></div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="test-buy-lists">
      <div class="page-header">
        <h2>
          {{ $t('testbuy.test_purchase_records') }}
          <el-select v-model="currentmonth" size="mini" class="test-buy-selectmonth" @change="getTestbuyList">
            <el-option
              v-for="item in month"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="activestatus" size="mini" clearable class="test-buy-selectmonth" @change="getTestbuyList">
            <el-option
              v-for="item in statustype"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
          <el-input 
            class="test-buy-search"
            style="margin-left: 30px;"
            size="mini" 
            v-model="search" 
            :placeholder="$t('testbuy.search_assetid')"
            clearable
            @clear="getTestbuyList()"
            @keyup.enter.native="getTestbuyList()">
          </el-input>
          <el-button style="float: right;" type="danger" plain size="mini" @click="downloaddata()">{{ $t('jgjk.s74') }}</el-button>
        </h2>
      </div>
      <div class="test-buy-table">
        <el-table :data="tablelists" size="mini" v-loading="loading" :cell-style="getTableCellStyle" @sort-change="sortTableList">
          <el-table-column label="TBID" prop="testId" width="80" show-overflow-tooltip></el-table-column>
          <el-table-column label="ASSETID" prop="monitorId" width="80"></el-table-column>
          <el-table-column :label="$t('testbuy.order_number')" prop="orderNumer" width="150" show-overflow-tooltip></el-table-column>
          <el-table-column :label="$t('testbuy.order_amount')" prop="money" width="130" sortable='custom'>
            <template slot-scope="scope">
              {{ (scope.row.orderPrice * 1).toFixed(2) > 0 ? 
               (scope.row.orderPrice * 1).toFixed(2) : ''}}
            </template>
          </el-table-column>
          <el-table-column :label="$t('testbuy.product_name')" prop="productName" show-overflow-tooltip>
            <template slot-scope="scope">
              <a :href="scope.row.url" target="_blank">{{ scope.row.productName }}</a>
            </template>
          </el-table-column>
          <el-table-column :label="$t('jgjk.s226')" prop="skuMap" width="100" show-overflow-tooltip></el-table-column>
          <el-table-column :label="$t('testbuy.channel')" prop="channel" width="80">
            <template slot-scope="scope">
              <i class="channelicon" :class="setChannel(scope.row.channel).src"></i>
            </template>
          </el-table-column>
          <el-table-column :label="$t('report.s33')" prop="shopName" width="100" sortable='custom' show-overflow-tooltip></el-table-column>
          <el-table-column :label="$t('testbuy.order_time')" prop="orderTime" width="120" sortable='custom'>
            <template slot-scope="scope">
              {{ scope.row.orderTime != null ? $moment(scope.row.orderTime).format('YYYY-MM-DD') : '' }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('testbuy.status')" prop="status" width="110" sortable='custom' show-overflow-tooltip>
            <template slot-scope="scope">
              {{ setStatus(scope.row.status) }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('testbuy.status_buyer')" prop="userName" width="170" show-overflow-tooltip>
            <template slot-scope="scope">
              <div v-if="scope.row.userName != null">
                <span class="i-testbuyer">{{ scope.row.userName }}</span>
                <button class="editskulinkbtn" type="button" @click="selecttestbuyer=true; checktestbuyer=scope.row">
                  <i class="el-icon-edit"></i>
                </button>
              </div>
              <div v-else>
                <span class="i-testbuyer">{{ $t('testbuy.awaiting_assignment') }}</span>
                <button class="editskulinkbtn" type="button" @click="selecttestbuyer=true; checktestbuyer=scope.row">
                  <i class="el-icon-edit"></i>
                </button>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('Seller.t13')" prop="note" width="100" show-overflow-tooltip></el-table-column>
          <el-table-column :label="$t('jgjk.s51')" width="150">
          <!-- <el-table-column :label="$t('jgjk.s51')" width="150" v-if="userinfo.email.indexOf('simplybrand.com') != -1">   -->
            <template slot-scope="scope">
              <button class="editskulinkbtn" type="button" @click="editLink(scope.row.testId)" :disabled="scope.row.testId == null"><i class="el-icon-edit-outline"></i></button>
              <button class="editskulinkbtn" type="button" @click="showOrderimg(scope.row.orderPhoto)" :disabled="scope.row.orderPhoto == null"><i class="el-icon-picture-outline"></i></button>
              <button class="editskulinkbtn" type="button" @click="reportLink(scope.row.testId)" :disabled="scope.row.testId == null"><i class="el-icon-s-data"></i></button>
              <el-popconfirm title="确定复制这条工单？" @confirm="copyOrder(scope.row)">
                <button slot="reference" class="editskulinkbtn editskulinkbtn1" type="button"><i class="el-icon-document-copy"></i></button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagewrap">
        <el-pagination
          small
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page"
          popper-class="pagesizeclass"
          :page-sizes="[25, 50, 100]"
          :page-size="size"
          layout="total, prev, pager, next, sizes"
          :total="pagingtotal">
        </el-pagination>      
      </div>
    </div>

    <el-dialog
      custom-class="test-buy-show-orderimg"
      :visible.sync="showorderimg"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="true"
      :append-to-body="true">
      <el-image :src="orderimg">
        <div slot="placeholder" class="image-slot">
          <i class="el-icon-loading"></i>
        </div>
      </el-image>
    </el-dialog>
    
    <el-dialog
      :title="$t('testbuy.assign_buyer')"
      custom-class="test-buy-show-selecttestbuyer"
      :visible.sync="selecttestbuyer"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="true"
      :append-to-body="true">
      <div class="selecttestbuyer-body">
        <el-form size="mini" label-width="80px">
          <el-form-item :label="$t('testbuy.assign_buyer')">
            <el-select style="width: 280px;" v-model="testbuyername" placeholder="请分配一个买手" size="mini">
              <el-option v-for="item in testbuyer" :key="item.userId" :label="item.username" :value="item.userId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="收货信息">
            <el-input type="textarea" :rows="3" resize="none" v-model="testbuyaddress" placeholder="例如：姓名，电话，地址"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="setTestbuyer()">确定</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

	</div>
</template>

<script>
import MiniBarChart from '@/components/Charts/MiniBarChart.vue'
export default {
  components: {
    MiniBarChart,
  },
  data(){
    return{
      taskid: this.getCurrentInfo().taskid,
      showorderimg: false,
      orderimg: '',
      currentmonth: '',
      today: new Date(),
      serach: '',
      statustype: [{
        name: this.$t('testbuy.status'),
        value: ''
      },{
        name: this.$t('testbuy.pending_orders'),
        value: 0
      },{
        name: this.$t('testbuy.awaiting_shipment'),
        value: 1
      },{
        name: this.$t('testbuy.in_transit'),
        value: 2
      },{
        name: this.$t('testbuy.report_generation'),
        value: 3
      },{
        name: this.$t('testbuy.report_delivered'),
        value: '5, 6, 7,10,11'
      },{
        name: this.$t('testbuy.return_in_progress'),
        value: 5
      },{
        name: this.$t('testbuy.refund_in_progress'),
        value: 6
      }],
      month: [{
        name: this.$t('testbuy.all'),
        value: ''
      },{
        name: this.$moment(this.today).format('YYYY-MM'),
        value: this.$moment(this.today).format('YYYY-MM')
      },{
        name: this.$moment(this.today).subtract(1, 'months').format('YYYY-MM'),
        value: this.$moment(this.today).subtract(1, 'months').format('YYYY-MM')
      },{
        name: this.$moment(this.today).subtract(2, 'months').format('YYYY-MM'),
        value: this.$moment(this.today).subtract(2, 'months').format('YYYY-MM')
      },{
        name: this.$moment(this.today).subtract(3, 'months').format('YYYY-MM'),
        value: this.$moment(this.today).subtract(3, 'months').format('YYYY-MM')
      },{
        name: this.$moment(this.today).subtract(4, 'months').format('YYYY-MM'),
        value: this.$moment(this.today).subtract(4, 'months').format('YYYY-MM')
      },{
        name: this.$moment(this.today).subtract(5, 'months').format('YYYY-MM'),
        value: this.$moment(this.today).subtract(5, 'months').format('YYYY-MM')
      }],
      chartcolors: [
        '#F6924F',
        '#F47373',
        '#7290F2',
        '#8C7BED',
        '#00BFFF',
        '#800080',
        '#FF00FF',
        '#C71585',
        '#FFB6C1',
        '#4B0082'
      ],
      tablelists: [],
      testbuytimeavg: [],
      loading: false,
      page: 1,
      size: 25,
      order: 10,
      search: '',
      pagingtotal: 0,
      dashboarddata: {
        totaltestbuy: 0,
        successtestbuy: 0,
        completepercent: 0,
      },
      statuscount: [{
        status: 0,
        count: 0,
        name: this.$t('testbuy.pending_orders'),
      },{
        status: 1,
        count: 0,
        name: this.$t('testbuy.awaiting_shipment'),
      },{
        status: 2,
        count: 0,
        name: this.$t('testbuy.in_transit'),
      },{
        status: 3,
        count: 0,
        name: this.$t('testbuy.report_generation'),
      },{
        status: 11,
        count: 0,
        name: this.$t('testbuy.report_delivered'),
      },{
        status: 5,
        count: 0,
        name: this.$t('testbuy.return_in_progress'),
      },{
        status: 6,
        count: 0,
        name: this.$t('testbuy.refund_in_progress'),
      }],
      status: {
        0: this.$t('testbuy.pending_orders'),
        1: this.$t('testbuy.awaiting_shipment'),
        2: this.$t('testbuy.in_transit'),
        3: this.$t('testbuy.report_generation'),
        4: this.$t('testbuy.return_refund'),
        5: this.$t('testbuy.returned'),
        6: this.$t('testbuy.refunded'),
        7: this.$t('testbuy.completed_returned'),
        8: this.$t('testbuy.cancelled_not_shipped'),
        9: this.$t('testbuy.cancelled_returned_delivery'),
        10: this.$t('testbuy.completed_refunded_account'),
        11: this.$t('testbuy.report_delivered'),
        12: this.$t('testbuy.completed_refunded'),
        13: this.$t('testbuy.completed_refunded'),
      },
      amount: {
        total: 0,
        used: 0
      },
      activestatus: '',
      userinfo: JSON.parse(localStorage.getItem("userinfo")).val,
      selecttestbuyer: false,
      testbuyername: '',
      testbuyer: [],
      checktestbuyer: {},
      testbuyaddress: ''
    }
  },

  mounted(){
    let that = this

    that.tablelists.forEach(item => {
      item.channelicon = that.setChannel(item.channel).src
    })

    that.testBuyDashboard()
    that.getTestbuyList()
    that.getTestbuyerLists()

  },

  methods: {
    
    editLink: function(tid){
      this.$router.push({name: 'TestbuyEdit', params: {Id: this.$route.params.Id, Testid: tid}})
    },
    
    reportLink: function(tid){
      this.$router.push({name: 'TestbuyReport', params: {Id: this.$route.params.Id, Testid: tid}})
    },
    
    formatprogress: function(percentage){
      return `${percentage}%` + `\n` + this.$t("testbuy.completion_rate")
    },

    showOrderimg: function(pic){
      this.orderimg = pic
      this.showorderimg = true
      console.log(this.orderimg)
    },

    /**
     * 地区排行柱状图--竖排
     */
     initBarChart4: function(dataitem, datavalue, cid){
      if(document.getElementById(cid) === null) return
      let myBarChart = this.$echarts.init(document.getElementById(cid))
      myBarChart.clear()
      myBarChart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
        },
        grid: {
          left: 80,
          top: 20,
          bottom: 20,
          right:20,
        },
        yAxis: {
          type: 'category',
          axisLabel: {
            color: 'rgba(51,51,51,.4)',
            fontSize: 10
            // interval: 0, // 0 表示显示全部刻度
          },
          axisTick: {
            alignWithLabel: true,
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#EAEAEA'
            }
          },
          splitLine: {
            show: false
          },
          data: dataitem
        },
        xAxis: {
          type: 'value',
          axisLabel: {
            color: 'rgba(51,51,51,.4)',
            interval: 'auto',
          },
          axisTick: {
            show: false
          },
          axisLine: { 
            show: false,
            lineStyle: {
              color: '#EAEAEA',
            }
          },
          splitLine: {
            show: false
          },
        },
        series: [{
          data: datavalue,
          type: 'bar',
          barWidth: '50%'
        }],
        color: ['#7290F2', '#F47373', '#F49256', '#F4C36F', '#8D7CED', '#CED2EB', '#D9D9D9']
      })
      $(window).resize(function () {
          myBarChart.resize();
      }); 
    },

    /**
     * 授权卖家占比
     */
    initBarChartAuthorized: function(dataitem, datavalue, cid){
      if(document.getElementById(cid) === null) return
      let myBarChart = this.$echarts.init(document.getElementById(cid))
      myBarChart.clear()
      myBarChart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
        },
        grid: {
          left: 50,
          top: 20,
          bottom: 20,
          right:20,
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            color: 'rgba(51,51,51,.4)',
            fontSize: 10
          },
          axisTick: {
            alignWithLabel: true,
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#EAEAEA'
            }
          },
          data: dataitem
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: 'rgba(51,51,51,.4)',
            interval: 'auto',
          },
          axisTick: {
            show: false
          },
          axisLine: { 
            show: false,
            lineStyle: {
              color: '#EAEAEA',
            }
          }
        },
        series: [{
          data: datavalue,
          type: 'bar',
          barWidth: '50%'
        }],
        color: ['#7290F2', '#F47373', '#F49256', '#F4C36F', '#8D7CED', '#CED2EB', '#D9D9D9']
      })
      $(window).resize(function () {
          myBarChart.resize();
      }); 
    },

    gotoBalance: function(){
      this.$router.push({name: 'TestbuyBalance', params: {Id: this.$route.params.Id}})
    },

    /**
     * 测买记录详情
     */
    getTestbuyList: function(){
      let that = this
      that.loading = true
      let url = that.API_URL + '/v3/price/testbuy/paging?taskId=' + that.taskid
      + '&page=' + that.page + '&size=' + that.size + '&time=' + that.currentmonth
      + '&search=' + that.search + '&order=' + that.order + '&status=' + that.activestatus
      $.ajax({
        url:  url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
					console.log('getTestbuyList', rex)
          that.tablelists = rex.results[1]
          that.pagingtotal = rex.results[0][0].Count
          that.loading = false
        },
        error: function(response) {
          console.log('getTestbuyList', response)
        }
      })
    },

    /**
     * 修改每页显示条数
     */
    handleSizeChange: function(val){
      this.size = val
      this.page = 1
      this.getTestbuyList()
    },

    /**
     * 翻页
     */
    handleCurrentChange: function(val){
      this.page = val
      this.getTestbuyList()
    },

    /**
     * 测买图表
     * @param {*} s 
     */
    testBuyDashboard: function(){
      let that = this
      let url = that.API_URL + '/v3/price/testbuy/dashboard?taskId=' + that.taskid
      $.ajax({
        url:  url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
					console.log('testBuyDashboard', rex)
          let res = rex.results
          that.dashboarddata.totaltestbuy = res[0].totalCount
          that.dashboarddata.successtestbuy = res[0].count
          that.dashboarddata.completepercent = res[0].totalCount != 0 && res[0].totalCount != null ? 
                                              ((res[0].count / res[0].totalCount) * 100).toFixed(2) * 1 : 0
          that.testbuytimeavg = [{
            "value": (res[1].sysAvgCount * 1).toFixed(2),
            "itemStyle": {
              "color": "#F0AD4E"
            }
          }, {
            "value": (res[1].avgCount * 1).toFixed(2),
            "itemStyle": {
              "color": "#428bca"
            }
          }, {
            "value": res[1].maxtimeCount,
            "itemStyle": {
              "color": "#D9534F"
            }
          }, {
            "value": res[1].mintimeCount,
            "itemStyle": {
              "color": "#1CAF9A"
            }
          }]
          let _statusvalue = res[2]
          for(let i=0; i<_statusvalue.length; i++){
            for(let k=0; k<that.statuscount.length; k++){
              if(_statusvalue[i].status == that.statuscount[k].status){
                that.statuscount[k].count = _statusvalue[i].count
              }
            }
          }

          that.amount.used = res[4][1][0].totalPrice * 1
          that.amount.total = res[5][0][0].totalAmount != null ? res[5][0][0].totalAmount * 1 : 0

          let piechartdataitem = []
          for(let i=0; i<that.statuscount.length; i++){
            piechartdataitem.push(that.statuscount[i].count/1)
          }
          that.initBarChartAuthorized(that.statuscount.map(item => {return item.name}), piechartdataitem, 'barchartid3')
        
          /**
           * 地区排行
           */
          let directData = res[3]
          let _directdataitem = []
          let _directdatavalue = []
          for(let x=0; x<directData.length; x++){
            _directdataitem.push(directData[x].receiptAddress == null ? '其他' : directData[x].receiptAddress)
            _directdatavalue.push(directData[x].count)
          }
          let chartid4data = []
          for(let i=0; i<directData.length; i++){
            let _item = {
              value: directData[i].count,
              itemStyle: {
                  color: that.chartcolors[i]
              }
            }
            chartid4data.push(_item)
          }
          that.initBarChart4(_directdataitem.reverse(), chartid4data.reverse(), 'barchartid4')
          
        },
        error: function(response) {
          console.log('testBuyDashboard', response)
        }
      })
    },

    /**
     * 列表状态
     */
    setStatus: function(s){
      return this.status[s] || ''
    },

    /**
     * 自定义排序
     */
    sortTableList: function(column){
      let that = this
      if(column.order == "ascending"){
        switch(column.prop) {
          case 'money':
            that.order = '00'
            break
          case 'orderTime':
            that.order = '10'
            break
          case 'status':
            that.order = '20'
            break
          case 'shopName':
            that.order = '30'
            break
        }
      }
      if(column.order == "descending"){
        switch(column.prop) {
          case 'money':
            that.order = '01'
            break
          case 'orderTime':
            that.order = '11'
            break
          case 'status':
            that.order = '21'
            break
          case 'shopName':
            that.order = '31'
            break
        }
      }
      if(column.order == null){
        that.order = ''
      }
      that.getTestbuyList()
    },

    activeTestbuyList: function(status){
      this.activestatus = status
      this.getTestbuyList()
    },
    

    /**
     * 下载数据
     */
    downloaddata: function(){
      let that = this
      let url = that.API_URL + '/v3/price/testbuy/download?taskId=' + that.taskid
      let setdate = new Date()
      let filename = setdate.getTime()
      let xhr = new XMLHttpRequest()
      xhr.open('GET', url, true)
      xhr.setRequestHeader("Authorization", 'Bearer '+JSON.parse(localStorage.getItem("token")).val+'')
      xhr.responseType = "blob"
      xhr.onload = function () {
        if (this.status === 200) {
          var blob = this.response;
          var reader = new FileReader()
          reader.readAsDataURL(blob)
          reader.onload = function (e) {
            var a = document.createElement('a')
            a.download = 'Test-Buy-' + filename + '.xlsx'
            a.href = e.target.result
            $("body").append(a)
            a.click()
            $(a).remove()
          }
        }
      }
      xhr.send()      
    },

    /**
     * 获取买手信息
     */
    getTestbuyerLists: function(){
      let that = this
      let url = that.API_URL + '/v3/price/testbuy/buyerInfo'
      $.ajax({
        url:  url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(res) {
					console.log('getTestbuyerLists', res)
          that.testbuyer = res.results
        },
        error: function(err) {
          console.log('getTestbuyerLists', err)
        }
      })
    },

    /**
     * 设置买手
     */
    setTestbuyer: function(){
      let that = this
      let url = that.API_URL + '/v3/price/testbuy/editbuyerId'
      let obj = that.checktestbuyer
      let _query = {
        testId: obj.testId,
        userId: that.testbuyername,
        receiveInfo: that.testbuyaddress,
        appointUserId: that.userinfo.mainid,
      }
      $.ajax({
        url:  url,
        type: "POST",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
				data: _query,
        changeOrigin: true,
        crossDomain: true,
        success: function(res) {
					console.log('setTestbuyer', res)
          that.testbuyername = ''
          that.selecttestbuyer = false
          that.getTestbuyList()
        },
        error: function(err) {
          console.log('setTestbuyer', err)
        }
      })
    },

    /**
     * 复制工单
     */
    copyOrder: function(obj){
      let that = this
      let url = that.API_URL + '/v3/price/testbuy/add' 
      let _query = {
        assetId: obj.assetId
      }
      $.ajax({
        url:  url,
        type: "POST",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
				data: _query,
        changeOrigin: true,
        crossDomain: true,
        success: function(res) {
					console.log('setTestbuyer', res)
          that.getTestbuyList()
        },
        error: function(err) {
          console.log('setTestbuyer', err)
        }
      })

    },

  }
}
</script>